<template>
    <v-app>
        <Drawer v-show="$route.meta.showMenu"/>
        <Toolbar />
        <v-content :class="$route.meta.showMenu?'has-menu':'no-menu'">
            <v-container fluid :class="{'pa-1': $vuetify.breakpoint.mdAndDown, 'pa-4': $vuetify.breakpoint.mdAndUp}">
                <notifications app position="bottom center" max-width="40%" />
                <transition name="fade" mode="out-in">
                    <router-view>

                    </router-view>
                </transition>
            </v-container>
        </v-content>
        <v-snackbar v-model="$store.state.toastMessageVisible">
            {{$store.state.toastMessage}}
        </v-snackbar>
    </v-app>
</template>

<script>
import Drawer from '@/components/Shared/Drawer'
import Toolbar from '@/components/Shared/Toolbar'


export default {
    name: 'App',
    components: {
        Drawer,
        Toolbar
    },
    data() {
        return {
            playing:false
        }
    },
    beforeMount () {
        this.$store.watch((state) => {
            return this.$store.state.user.language
        }, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (this.$store.state.user.language) {
                    this.$i18n.locale = this.$store.state.user.language
                }
            }
        })
        this.$store.watch((state) => {
            return this.$store.state.auth.token
        }, (newValue, oldValue) => {
            if (!newValue && oldValue !== null) {
                this.$router.push('/')
                this.$notify({
                    group: 'default',
                    type: 'warning',
                    title: this.$t('alerts.expired.title'),
                    text: this.$t('alerts.expired.text')
                })
            }
        })
        this.$router.beforeResolve((to, from, next) => {
            if (!this.$store.state.auth.token && to.meta.secure === true) {
                this.$router.push('/')
            } else if (this.$store.state.auth.token && to.meta.secure === false) {
                this.$router.push('/dashboard')
            } else {
                next()
            }
        })
        this.$router.afterEach((to, from) => {
            document.title = this.$store.state.app.title + ' | ' + this.$t('views.' + to.meta.title)
        })
    }
}
</script>
<style>
    @import url('https://fonts.googleapis.com/css?family=Raleway:100,300,400,500,700,900|Material+Icons');
    div,span,h1,h2,h3,p{
        font-family: Raleway;
    }
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }
    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
    a{
        max-width: 100%;
        overflow-wrap: break-word;
    }
    p{
        font-size:16px;    
        max-width: 100%;
    }
    h1{
        text-transform: uppercase;
    }
    .layout{
        padding:20px;
    }
    .v-navigation-drawer .layout{
        padding:0;
    }
    h1,h2,h3{
        min-width:100%;
    }
    .v-expansion-panel__header{
        background: #000000;
        color: white;
    }
    .theme--light.v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon{
        color:white;
    }
    .v-card__title{
        display: block;
        text-align: center;
    }
    .v-card__text{
        text-align: justify;
        font-size:16px;
    }
    main{
        margin-top:env(safe-area-inset-top)!important;
    }
    nav{
        padding-top:env(safe-area-inset-top)!important;
    }
    aside{
        margin-top: calc(64px + env(safe-area-inset-top)) !important;
    }
    @media all and (max-width:1000px){
        aside{
            margin-top: calc(56px + env(safe-area-inset-top)) !important;
        }
    }
    .v-card{
        margin-bottom:10px;
        border-radius:8px;
        cursor:pointer;
    }
    .v-dialog{
        font-size:16px;
    }
    .v-dialog .v-card{
        margin-bottom:0;
    }
    .field-title{
        font-weight: 500;
        display:inline-block;
        text-align:left;
        min-width:250px;
        font-size:16px;
    }
    .field-value{
        font-size:16px;
        text-align:left;
        min-width: calc(100% - 300px);
    }
    .overflow-y-hidden main{
        margin-left:200px;
    }
    .v-toolbar{
        box-shadow: none;
    }
    .v-btn--floating.v-btn--absolute{
        position: fixed;
    }
    .container{
        padding:10px;
    }
    .v-card.selected{
        background:#4caf50;
        color:white;
    }
    .not-multiselecting .card-checkbox{
        display: none;
    }
    .card-checkbox{
        float:left;
        display: inline;
        position: relative;
        left:-10px;
        margin:20px;
    }
    .card-checkbox i{
        font-size:0;
        border:3px solid gray;
        padding:10px;
        position: relative;
    }
    .selected .card-checkbox i{
        color:white!important;
        border:none;
        font-size:40px;
        left:0;
        padding: 0;
        left:-5px;
    }
    .inline-block{
        display: inline-block;
    }
    .card-chev {
        border-right:10px solid black;
        border-bottom:10px solid black;
        width:30px;
        height:30px;
        transform: rotate(-45deg);
        border-color:#00000038;
        float: right;
        margin-top:25px;
    }
    .results-count{
        text-align:right;
    }
    .ec-now-indicator{
        z-index:90!important;
    }
    .ec-event{
        color:black!important;
        cursor:pointer;
    }
    .accent--text {
        color: #222222 !important;
        caret-color: #5c5c5c !important;
    }
    .no-menu{
        padding: 64px 0px 0px!important;
    }
    .vrow{
        display: inline-block;
        width:48%;
        padding-right:2%;
        vertical-align: top;
    }
    @media all and (max-width:500px){
        .vrow{
            width:100%;
            padding-right:0;
        }
    }
    .v-form{
        width:100%;
    }
    h4{
        font-size: 20px;
    }
    .italic{
        font-style: italic;
    }
    .overflow-y-hidden main{
        margin-left: 0;
    }
    .language-picker{
        font-weight: 500;
        text-transform: uppercase;
        font-size:18px;
        text-decoration:underline;
        text-decoration-style: dotted;
        text-underline-offset:4px;
        padding:5px;
    }
    .language-picker option{
        background:#4caf50;
    }
    .language-picker:hover{
        cursor:pointer;
    }
    .theme--light.v-chip.anatomic-part{
        background: #03A9F4;
        color: white;
        font-weight: 500;
    }
    .theme--light.v-chip.continent{
        background: #8bc34a;
        font-weight: 500;
    }
    .theme--light.v-chip.variability{
        background: #673ab7;
        color: white;
        font-weight: 500;
    }
    .theme--light.v-chip.data-type{
        background: #bb3a6d;
        color: white;
        font-weight: 500;
    }
    .theme--light.v-chip.techniques{
        background: #d18f0c;
        color: white;
        font-weight: 500;
    }
    .bottom-bar-holder{
        position:fixed;
        bottom:0;
        float:right;
        width:100%;
        left:0;
        z-index:99;
    }
    .bottom-bar{
        border-radius:80px 80px 0 0;
        background:rgba(200,200,200,0.2);
        border:1px solid #ccc;
        width: 800px;
        max-width: 90%;
        margin:auto;
        backdrop-filter: blur(7px);
    }
    .filters-count{
        color:white;
        background:#f44336;
        border-radius:80px;
        height:22px;
        width:22px;
        padding:0;
        margin:0;
        line-height: 20px;
        font-size:16px;
    }
    @media screen and (max-width:820px){
        .bottom-bar{
            border-radius:0;
            width:100;
            max-width:100%;
        }
        .bottom-bar .v-btn{
            margin:3px;
            padding:5px;
        }
        .bottom-bar .v-btn .v-btn__content{
            font-size:10px;
        }
    }
    @media screen and (max-width:470px){
        .layout.wrap{
            padding:0;
        }
        .home-button{
            width: 90vw!important;
            min-width: 0!important;
            
        }
    }
</style>
